import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { SharedModule } from "../shared/shared.module";

import { UploadListComponent } from "./upload-list/upload-list.component";
import { UploadComponent } from "./upload.component";
import { UploadFormComponent } from "./upload-form/upload-form.component";
import { UploadProviderComponent } from "./upload-form/upload-provider/upload-provider.component";
import { UploadSimulationComponent } from "./upload-form/upload-simulation/upload-simulation.component";
import { FilesTableComponent } from "./upload-list/files-table/files-table.component";
import { RouterModule } from "@angular/router";
import { UploadBizzdevComponent } from "./upload-form/upload-bizzdev/upload-bizzdev.component";
import { AdvancedOverviewModule } from "./../dashboard/advanced/advanced-overview.module";

@NgModule({
    declarations: [
        UploadComponent,
        UploadListComponent,
        UploadFormComponent,
        UploadProviderComponent,
        UploadSimulationComponent,
        FilesTableComponent,
        UploadBizzdevComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        AdvancedOverviewModule,
    ],
    providers: [DatePipe],
})
export class UploadModule {}
